import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getImage } from '../../../../utils/cloudinarySizing';

const JobBox = ({ jobs }) => {
    const navigate = useNavigate();
    const [brokenImages, setBrokenImages] = useState({});
    const [loadedImages, setLoadedImages] = useState({});

    const handleJobClick = (id) => {
        navigate(`/service-requests/${id}`);
    };

    const formatBudget = (job) => {
        const budget = parseFloat(job.budget);
        if (isNaN(budget)) return "TBD";
        return budget % 1 === 0 ? budget.toFixed(0) : budget.toFixed(2);
    };

    return (
        <div className="job-box">
            <h3><i className="fa-solid fa-wrench"></i> Service Requests</h3>

            {jobs.length > 0 && (
                <p className="media-results-count">
                    {jobs.length} service request{jobs.length !== 1 && 's'}
                </p>
            )}

            <div className="job-list">
                {jobs.length === 0 ? (
                    <p className="text-gray-400">No service requests posted yet.</p>
                ) : (
                    jobs.map((job, index, arr) => {
                        const imageUrl =
                            job.images?.length > 0
                                ? getImage(job.images[0].image, "srv_sm")
                                : null;

                        const showImage =
                            imageUrl &&
                            !brokenImages[job.id] &&
                            loadedImages[job.id];

                        return (
                            <div key={job.id}>
                                <div
                                    className="job-item"
                                    onClick={() => handleJobClick(job.id)}
                                >
                                    {showImage ? (
                                        <img
                                            src={imageUrl}
                                            alt="Job thumbnail"
                                            className="job-thumbnail"
                                        />
                                    ) : (
                                        <div className="service-request-placeholder">
                                            <span>No Image</span>
                                        </div>
                                    )}

                                    {imageUrl &&
                                        !brokenImages[job.id] &&
                                        !loadedImages[job.id] && (
                                            <img
                                                src={imageUrl}
                                                alt=""
                                                style={{ display: "none" }}
                                                onLoad={() =>
                                                    setLoadedImages(prev => ({
                                                        ...prev,
                                                        [job.id]: true
                                                    }))
                                                }
                                                onError={() =>
                                                    setBrokenImages(prev => ({
                                                        ...prev,
                                                        [job.id]: true
                                                    }))
                                                }
                                            />
                                        )}

                                    <div className="job-info">
                                        <strong>{job.title}</strong>
                                        <p className="job-detail">{job.description}</p>

                                        <p className="job-meta">
                                            <strong>Pay:</strong>{" "}
                                            <i className="fas fa-dollar-sign money-icon"></i>{" "}
                                            {formatBudget(job)} / {job.budget_type}
                                            <span className="separator">|</span>
                                            <i className="fas fa-location-dot location-icon"></i>{" "}
                                            <strong>Location:</strong> {job.location}
                                        </p>
                                    </div>
                                </div>

                                {index < arr.length - 1 && (
                                    <hr className="menu-separator" />
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default JobBox;